<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 자료구분 -->
          <c-select
            :comboItems="comboDocumentTypeItems"
            itemText="codeName"
            itemValue="code"
            type="search"
            name="ramDocumentTypeCd"
            label="자료구분"
            v-model="searchParam.ramDocumentTypeCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="관련자료 목록"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      selection="multiple"
      rowKey="documentId"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
          <c-btn v-if="editable" label="LBLSELECT" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'jsa-relation-docu',
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
        }
      },
    }
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'ramDocumentTypeName',
            field: 'ramDocumentTypeName',
            label: 'LBLCLASSIFICATION',
            align: 'center',
            style: 'width:50%',
            sortable: false,
          },
          {
            name: 'documentTitle',
            field: 'documentTitle',
            description: 'documentSubTitle',
            label: 'LBLTITLE',
            align: 'left',
            style: 'width:50%',
            sortable: false,
          },
        ],
        data: [],
        height: '650px'
      },
      searchParam: {
        plantCd: null,
        ramDocumentTypeCd: null,
      },
      comboDocumentTypeItems: [],
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.relatedDocument.addData.url;
      // code setting
      this.$comm.getComboItems('RAM_DOCUMENT_TYPE_CD').then(_result => {
        this.comboDocumentTypeItems = this.$_.reject(_result, { code: 'RDT0000020' })
      });
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: '하나 이상 선택하세요', // 사용자를 먼저 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
  }
};
</script>
